/**
 * 直播管理 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const meetingRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "/meeting-management",
    name: "MeetingManagement",
    meta: {
      title: "直播管理",
      icon: "icon-meeting",
    },
    children: [
      {
        path: "/meeting/apply",
        name: "MeetingApply",
        component: () => import("../pages/meeting/apply/index.vue"),
        meta: {
          title: "会议列表",
          keepAlive: true,
        },
      },
      {
        path: "/meeting/manage/list",
        name: "MeetingManageList",
        component: () => import("../pages/meeting/manage/index.vue"),
        meta: {
          title: "会议管理",
          keepAlive: true,
        },
      },
      {
        path: "/meeting/manage/create",
        name: "MeetingManageCreate",
        component: () => import("../pages/meeting/manage/create.vue"),
        hidden: true,
        meta: {
          type: "create",
          title: "新增会议",
          relatedPermission: "会议管理",
        },
      },
      {
        path: "/meeting/manage/edit",
        name: "MeetingManageEdit",
        component: () => import("../pages/meeting/manage/create.vue"),
        hidden: true,
        meta: {
          type: "edit",
          title: "编辑会议",
          relatedPermission: "会议管理",
        },
      },
      {
        path: "/meeting/list",
        name: "MeetingList",
        component: () => import("../pages/meeting/list/index.vue"),
        meta: {
          title: "直播列表",
          // keepAlive: true,
        },
      },
      {
        path: "/meeting/message",
        name: "Message",
        component: () => import("../pages/meeting/message/index.vue"),
        meta: {
          title: "消息管理",
          keepAlive: false,
        },
      },
    ],
  },
];
export default meetingRoute;
